<button class="w-full mt-2" mat-flat-button [color]="color" type="button" (click)="event(click)">
    <ng-content></ng-content>
</button>